import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import style from './CanvasDraw.module.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(style);

function CanvasDraw({ cameraCode, listPosition , width = 617, height = 354}) {
    const canvasRef = useRef(null);
    const [canvas, setCanvas] = useState(null);

    useEffect(() => {
        setCanvas(canvasRef.current);
        const ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    }, [canvasRef, width, height]);

    const drawPolygon = (ctx, lines) => {
        const [x, y] = lines;
        const size = 20;

        ctx.fillStyle = "#e8e8e846";
        ctx.fillRect(x - size / 2, y - size / 2, size, size);

        ctx.strokeStyle = "#00B335";
        ctx.lineWidth = 2;
        ctx.strokeRect(x - size / 2, y - size / 2, size, size);

        ctx.font = "14px Arial";
        ctx.fillStyle = "#00B335";
        ctx.fillText("X", x - 5, y + 5);
    };
    
    useEffect(() => {
        if (canvas && listPosition) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            listPosition?.forEach((reg) => {
                drawPolygon(ctx, reg);
            })
        }
    }, [canvas, listPosition, width, height])

    useLayoutEffect(() => {
        if (canvas) {
            const ctx = canvas.getContext("2d");
            const dpr = window.devicePixelRatio;
            canvas.width = width;
            canvas.height = height;
            // ctx.scale(dpr, dpr);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
    }, [canvas, width, height]);


    return (
        <div className={cx('box-video')}>
            <canvas
                ref={canvasRef}
                className={cx('canvas-space')}
            />
        </div>
    )
}

export default CanvasDraw;